module.exports = "<div class=left-list-all-box> <div class=left-list-blank> </div> </div> ";